export default "__VITE_ASSET__Cz7qR_jO__"